<p>view-service-administration works!</p>
